export function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString("nl-NL", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

// Fix#5d — cross-component signal so tab badges refresh immediately after a mutation.
export function notifyAdminBadgesDirty() {
  window.dispatchEvent(new Event("tw1:admin-badges-dirty"));
}

export function topCategory(by) {
  if (!by) return null;
  const entries = Object.entries(by);
  if (entries.length === 0) return null;
  entries.sort((a, b) => b[1] - a[1]);
  const [name, count] = entries[0];
  if (!count) return { name: "—", count: 0 };
  return { name, count };
}

export function truncateUrl(url) {
  if (!url) return "";
  try {
    const u = new URL(url);
    return `${u.host}${u.pathname}`;
  } catch {
    return url.length > 60 ? url.slice(0, 60) + "…" : url;
  }
}

export function formatRelativeNl(iso) {
  if (!iso) return "nog nooit";
  try {
    const d = new Date(iso);
    const diffMs = Date.now() - d.getTime();
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (days === 0) return "vandaag";
    if (days === 1) return "gisteren";
    if (days < 7) return `${days} dagen geleden`;
    if (days < 14) return "vorige week";
    if (days < 30) return `${Math.floor(days / 7)} weken geleden`;
    if (days < 365) return `${Math.floor(days / 30)} maanden geleden`;
    return `${Math.floor(days / 365)} jaar geleden`;
  } catch {
    return iso;
  }
}

export function formatDurationSec(sec) {
  const s = Math.max(0, Math.floor(sec || 0));
  const m = Math.floor(s / 60);
  const r = s % 60;
  if (m === 0) return `${r}s`;
  return `${m}m ${r.toString().padStart(2, "0")}s`;
}

export function isSilent(row) {
  // "STIL" = zero memos OR last memo older than 14 days.
  if (!row.memo_count) return true;
  if (!row.last_memo_at) return true;
  const days = (Date.now() - new Date(row.last_memo_at).getTime()) / (1000 * 60 * 60 * 24);
  return days > 14;
}

export function fmtTs(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("nl-NL", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}

export function parseFuncties(input) {
  if (!input) return [];
  if (Array.isArray(input)) return input.map((f) => String(f).trim()).filter(Boolean);
  return String(input)
    .split(",")
    .map((f) => f.trim())
    .filter(Boolean);
}
